skrilla.controller('publishEventsModalCtrl', async function ($scope, searchService, modalService, cacheService, queryService, bettingReferenceService, sportService) {
    $scope.sports = await sportService.getSports()
    $scope.eventTypes =  bettingReferenceService.eventTypes().reduce((a, v) => ({ ...a, [v]: false}), {});
    const startTime = new Date()
    const endTime = new Date()
    endTime.setDate(endTime.getDate() + 3);
    $scope.query = {
        sport: null,
        marketStatuses: {
            SUSPENDED: false,
            DEACTIVATED: false,
            UNAVAILABLE: false,
            ACTIVE: true,
            HANDED_OVER: false,
            SETTLED: false,
            CANCELLED: false,
        },
        eventTypes: $scope.eventTypes,
        startTime,
        endTime,
    }

    $scope.publish = function () {

        const request = {
            ...queryService.normaliseQueryObject($scope.query),
            startTime: $scope.query.startTime,
            endTime: $scope.query.endTime,
        }
        searchService.post("betting/events/publish", request, "Betting markets publication requested. This task will continue in background.", true).then(function (response) {
            console.log("Betting markets published")
        })
    }
});
